import React from "react";
import Plot from "react-plotly.js";

type ScatterPlotProps = {
  data: {
    group_values: { [key: string]: string };
    "vin": string[];
    combinedData: { [key: string]: number[] };
  };
  selectedVinGroup: any;
};

const ScatterPlot = (props: ScatterPlotProps) => {
  const { data, selectedVinGroup } = props;
  const groupColors = {
    GroupA: "#1f77b4",
    GroupB: "#ff7f0e", 
  };

  if (!data || !data.group_values || !data["vin"] || !data.combinedData) {
    return <div>No data available</div>;
  }

  const combinedDataKeys = Object.keys(data.combinedData);
  const xKey = combinedDataKeys[0];
  const yKey = combinedDataKeys[1];

  if (!xKey || !yKey) {
    return <div>Invalid data format</div>;
  }

  const vinGroupMapping: Record<string, string> = {};
  if (selectedVinGroup && Array.isArray(selectedVinGroup)) {
    selectedVinGroup.forEach((group) => {
      if (group.dropdown1) {
        group.dropdown1.forEach((vin: string) => {
          vinGroupMapping[vin] = "GroupA"; 
        });
      }
      if (group.dropdown2) {
        group.dropdown2.forEach((vin: string) => {
          vinGroupMapping[vin] = "GroupB";
        });
      }
    });
  }
  const mappedGroupValues = data.vin.map((_, index) => {
    const vin = data.group_values[data.vin[index]] || "Unknown VIN";
    const group = selectedVinGroup.dropdown1.includes(vin)
      ? "Group A"
      : selectedVinGroup.dropdown2.includes(vin)
      ? "Group B"
      : null
  
    return { vin, group }; 
  });

  const groupATrace: Partial<Plotly.ScatterData> = {
    x: Array.isArray(data.combinedData[xKey]) ? 
    data.combinedData[xKey]
      .filter((_, index) => mappedGroupValues[index].group === "Group A" && !isNaN(data.combinedData[xKey][index])) : [],
    y: Array.isArray(data.combinedData[yKey]) ? 
    data.combinedData[yKey]
      .filter((_, index) => mappedGroupValues[index].group === "Group A" && !isNaN(data.combinedData[yKey][index])) : [],
    mode: "markers",
    type: "scatter",
    name: "Group A", 
    marker: { size: 8, symbol: 'circle', color: groupColors.GroupA },
    legendgroup: "Group A", 
    text: mappedGroupValues
      .filter((_, index) => mappedGroupValues[index].group === "Group A")
      .map(({ vin, group }, index) => 
        `VIN: ${vin}<br> Group: ${group}<br> X: ${data.combinedData[xKey][index]}, Y: ${data.combinedData[yKey][index]}`
      ), 
    hoverinfo: "text", 
  };
  
  const groupBTrace: Partial<Plotly.ScatterData> = {
    x: Array.isArray(data.combinedData[xKey]) ? 
    data.combinedData[xKey]
      .filter((_, index) => mappedGroupValues[index].group === "Group B" && !isNaN(data.combinedData[xKey][index])) : [],
    y: Array.isArray(data.combinedData[yKey]) ? 
    data.combinedData[yKey]
      .filter((_, index) => mappedGroupValues[index].group === "Group B" && !isNaN(data.combinedData[yKey][index])) : [],
    mode: "markers",
    type: "scatter",
    name: "Group B",
    marker: { size: 8, symbol: 'circle', color: groupColors.GroupB },
    legendgroup: "Group B", 
    text: mappedGroupValues
      .filter((_, index) => mappedGroupValues[index].group === "Group B")
      .map(({ vin, group }, index) => 
        `VIN: ${vin}<br> Group: ${group}<br> X: ${data.combinedData[xKey][index]}, Y: ${data.combinedData[yKey][index]}`
      ),
    hoverinfo: "text",
  };

  return (
    <div>
      <Plot
        data={[groupATrace, groupBTrace]} 
        layout={{
          title: `${yKey} vs ${xKey}`,
          xaxis: { title: xKey },
          yaxis: { title: yKey },
          hovermode: "closest",
          showlegend: true, 
        }}
        style={{ width: "100%", height: "100%" }}
      />
    </div>
  );
};

export default ScatterPlot;